import { Button, CircularProgress, FormControl, Grid, IconButton, InputLabel, MenuItem, Paper, Select, TextField } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import { DeleteIcon } from '../Common/TableUI';
import { useDispatch } from 'react-redux';
import ConfirmDialog from '../Common/ConfirmDialog';
import { addNewAssetName, deleteAssetName, getAssetNameById, setStoreData, updateAssetName } from '../../Redux/actions';

export default function ManageInventory () {

    let { id, tabId } = useParams()
    let navigate = useNavigate()
    const dispatch = useDispatch();
    const location = useLocation();

    let initialForm = {
        assetName: '',
    }

    const inventoryQueryParams = localStorage.getItem('inventoryQueryParams')

    const [form, setForm] = useState(initialForm);
    const [showConfirmDialog, setShowConfirmDialog] = useState(false);
    const [showLoader, setShowLoader] = useState( id ? true : false )
    const error = {};
    const [errors, setErrors] = useState(error);
    const [disableButton, setDisableButton] = useState(false);
    const [selectedItem, setSelectedItem] = useState(null);
    const [itemNotFound, setItemNotFound] = useState(false);

    useEffect(() => {
        if (id) {
            dispatch(getAssetNameById(id)).then((resp) => {
                const response = resp?.data?.assetName
                if (!response) {
                    setItemNotFound(true);
                    setShowLoader(false)
                    return;
                }

                const { id, asset_name} = response
                
                const existData = {
                    assetName: asset_name,
                }
                setForm(existData)
                setShowLoader(false)
            })  
        }
    }, []);

    const handleChange = (e, fieldName) => {
        const { value } = e.target;
        const data = (prevState) => {
            let newData = {
                ...prevState,
                [fieldName]: value
            };
            return newData;
        };
        const err = Object.assign({}, errors);
        if (err[fieldName]) {
            err[fieldName] = null;
        }
        setErrors(err);
        setForm(data);
        if (disableButton) {
            setDisableButton(false)
        }
    }

    const updateResponse = (resp, message) => {
        const res = resp && resp.data;
        let msg = res.message;
        let type = "fail";
        if (res && res.success) {
            msg = message;
            type = "success";
        }
        dispatch(setStoreData('alertMessage', {
            msg, type,
            handleClose: () => handleCloseDialog(),
        }))
    };

    const handleCloseDialog = () => {
        dispatch(setStoreData('alertMessage', null))
        inventoryQueryParams ? 
        navigate(`/inventory-management/${tabId}?${inventoryQueryParams.toString()}`) :
        navigate(`/inventory-management/${tabId}`)
    }

    const triggerDelete = () => {
        setSelectedItem(id);
        setShowConfirmDialog(true);
    }

    const handleDeleteAssetName = () => {
        if (selectedItem) {
            setShowConfirmDialog(false);
            dispatch(deleteAssetName(selectedItem)).then((resp) => {
                updateResponse(resp, resp?.data?.message);
                setSelectedItem(null);
            })
        }
    }

    const validateData = () => {
        const err = { ...errors };
        let hasErrors = false;

        if (!form.assetName || form.assetName.trim() === '') {
            hasErrors = true;
            err.assetName = 'This field is mandatory';
        }

        if (hasErrors) {
            setErrors(err);
            return false;
        }
        return true;
    }

    const handleSubmit = async() => {
        setDisableButton(true)
        const checkForm = validateData();
        if ( checkForm ) {
            const data = {
                assetName: form.assetName,
            }

            if (id) {
                dispatch(updateAssetName(data, id)).then((resp) => {
                    setDisableButton(false)
                    if (!resp) {
                        return;
                    } else {
                        updateResponse(resp, resp?.data?.message);
                    }
                });
            } else {
                dispatch(addNewAssetName(data)).then((resp) => {
                    setDisableButton(false)
                    if (!resp) {
                        return;
                    } else {
                        updateResponse(resp, resp?.data?.message);
                    }
                });
            }
        }
    };

    if (showLoader) {
        return <Grid container>
            <Grid style={{display: 'flex', justifyContent: 'center', width: '100vw', height: '500px',  alignItems: 'center' }}>
                <CircularProgress />
            </Grid>
        </Grid>
    }

    if (id && itemNotFound && !showLoader) {
        return <Grid container >
            <Grid item md={12} className='w3-padding' style={{ display: 'flex', justifyContent: 'center' }}>
                <h5 className='w3-text-grey'>
                    No Data Found
                </h5>
            </Grid>
        </Grid>
    }

    return (
        <Paper elevation={1} style={{ margin: '16px' }}>
            <Grid container className='w3-padding-small'>
                <Grid container >
                    <Grid item md={12} className='w3-padding' style={{ display: 'flex' }}>
                        <IconButton
                            onClick={() => {
                                inventoryQueryParams ? 
                                navigate(`/inventory-management/${tabId}?${inventoryQueryParams.toString()}`) :
                                navigate(`/inventory-management/${tabId}`)
                            }}
                            color="inherit">
                            <ArrowBackIosIcon fontSize='small'/>
                        </IconButton>
                        <h6>{id ? 'Edit Item Name' : 'Add New Item Name'}</h6>
                    </Grid>
                    <Grid container item md={12} style={{ display: 'flex', flexDirection: 'row', }}>
                        <Grid container item md={12} className='w3-padding' style={{ alignContent: 'flex-start' }}>
                            <Grid item md={6} style={{ display: 'flex', flexDirection: 'row', }}>
                                <TextField
                                    fullWidth
                                    label="Item Name"
                                    required
                                    value={form.assetName}
                                    onChange={(e) => handleChange(e, 'assetName')}
                                    sx={{
                                        '& .MuiOutlinedInput-root': {
                                            '&.Mui-focused fieldset': {
                                                borderColor: '#008080',
                                            },
                                        },
                                        '& .MuiInputLabel-root.Mui-focused': {
                                            color: '#008080',
                                        },
                                    }}
                                />
                            </Grid>
                        </Grid>
                        {errors.assetName && <div style={{ marginTop: '-12px' }} className='error-text w3-padding'>{errors.assetName}</div>}
                    </Grid>
                    <Grid item md={12} style={{ display: 'flex', flexDirection: 'row' }} className='w3-padding-16'>
                        <Grid item md={6} style={{ display: 'flex', justifyContent: 'flex-start', paddingLeft: '16px' }} className='w3-margin-bottom'>
                            {id && (
                                <Button
                                    variant="outlined"
                                    startIcon={<DeleteIcon />}
                                    color="error"
                                    onClick={() => triggerDelete()}
                                    >
                                    Delete
                                    </Button>
                                )}
                        </Grid>
                        <Grid item md={12} style={{ display: 'flex', justifyContent: 'flex-end', paddingRight: '16px' }} className='w3-margin-bottom'>
                            <Button
                                style={{ borderColor: '#008080', color: '#008080'}}
                                variant="outlined"
                                onClick={() => {
                                    inventoryQueryParams ? 
                                    navigate(`/inventory-management/${tabId}?${inventoryQueryParams.toString()}`) :
                                    navigate(`/inventory-management/${tabId}`)
                                }}
                            >
                                Cancel</Button>
                                <Button
                                    variant="contained"
                                    onClick={handleSubmit}
                                    style={{ marginLeft: '10px', backgroundColor: '#008080', color: 'white' }}
                                    disabled={disableButton}
                                >
                                    Submit</Button>
                        </Grid>
                    </Grid>
                    {showConfirmDialog
                        ? (
                            <ConfirmDialog
                                handleCancel={() => {
                                    setSelectedItem({})
                                    setShowConfirmDialog(false)
                                }}
                                handleOk={handleDeleteAssetName}
                                message={'Are you sure to delete this?'}
                            />
                        ) : null}
                </Grid>
            </Grid>
        </Paper>
    )
}